import { Route } from '@angular/router';
import { BidImportOverviewComponent } from '../../../../../common/pages/bid-import/bid-import-overview/bid-import-overview.component';
import { BidImportReviewComponent } from '../../../../../common/pages/bid-import/bid-import-review/bid-import-review.component';

export let bidImportRoute: Route = {
  path: 'import/bid',
  children: [
    {
      path: '',
      component: BidImportOverviewComponent
    },
    {
      path: 'session/:sessionId/overview',
      component: BidImportOverviewComponent
    },
    {
      path: 'session/:sessionId/review',
      component: BidImportReviewComponent
    }
  ]
};
